import { FormControl, FormGroup } from '@angular/forms';

import { PositionAssignment, PositionHistoryEntryPayload } from '@core/tellent-positions-types';
import { PositionRowForm } from '@core/tellent-positions-ui';

export function makePositionRow(assignment?: PositionAssignment | null): PositionRowForm {
  return new FormGroup({
    id: new FormControl<number | null>(assignment?.id ?? null),
    positionGuid: new FormControl<string | null>(assignment?.positionGuid ?? null),
    startDate: new FormControl<string | null>(assignment?.startDate ?? null),
  });
}

export function positionRowValue(assignment?: PositionAssignment | null) {
  return {
    id: assignment?.id ?? null,
    positionGuid: assignment?.positionGuid ?? null,
    startDate: assignment?.startDate ?? null,
  };
}

export function isRowComplete(row: PositionRowForm): boolean {
  return !!row.controls.positionGuid.value && !!row.controls.startDate.value;
}

// A row nobody filled in is dropped rather than blocking the save, so a member without a current
// position is not forced to invent one.
export function isRowEmpty(row: PositionRowForm): boolean {
  return !row.controls.positionGuid.value && !row.controls.startDate.value;
}

export function rowEntry(row: PositionRowForm): PositionHistoryEntryPayload {
  return {
    id: row.controls.id.value,
    positionGuid: row.controls.positionGuid.value!,
    startDate: row.controls.startDate.value!,
  };
}

export function latestStartDate(rows: PositionRowForm[]): string | null {
  return rows
    .map(row => row.controls.startDate.value)
    .filter((date): date is string => !!date)
    .reduce<string | null>((latest, date) => (!latest || date > latest ? date : latest), null);
}
